import { Subject, takeUntil } from 'rxjs'
import { Injectable, OnDestroy } from '@angular/core'
import { GenericConfirmationDialogModel } from '../components/generic-confirmation-dialog/generic-confirmation-dialog.model'
import { GenericConfirmationDialogComponent } from '../components/generic-confirmation-dialog/generic-confirmation-dialog.component'
import { Dialog, DialogRef } from '@angular/cdk/dialog'
import { Store } from '@ngrx/store'
import { caseActions } from '../../state/case/case.actions'
import { Overlay } from '@angular/cdk/overlay'

@Injectable({
    providedIn: 'root',
})
export class JobUpdateDialogService implements OnDestroy {
    private readonly destroy$ = new Subject<void>()
    private dialogRef: DialogRef<string, unknown> | undefined

    constructor(
        private _overlay: Overlay,
        private readonly store: Store,
        private readonly dialog: Dialog
    ) {}

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    showJobUpdateDialog(): void {
        const data: GenericConfirmationDialogModel = {
            title: 'New jobs for the case have finished, do you want to reload?',
            confirmButtonLabel: 'Reload',
            cancelButtonLabel: 'Later',
        }
        if (this.dialogRef) return
        this.dialogRef = this.dialog.open<string>(GenericConfirmationDialogComponent, {
            data,
            autoFocus: 'dialog',
            hasBackdrop: false,
            positionStrategy: this._overlay
                .position()
                .global()
                .top('var(--top-bar-height-plus-margin)')
                .centerHorizontally(),
        })
        this.dialogRef.closed.pipe(takeUntil(this.destroy$)).subscribe(confirmed => {
            this.dialogRef = undefined
            if (!confirmed) return
            this.store.dispatch(caseActions.reloadCase())
        })
    }
}
